import { api, apiEndpoint } from "@core/ports/http";
import type { ZodType } from "@core/zod";
import { z } from "@core/zod";

import { API_DOMAIN } from "@platform/core";

import { TAXONOMY_SERVICE } from "../config/index.ts";
import type { TagId } from "../models/index.ts";
import { TagIdSchema, Taxonomy } from "../models/index.ts";

export interface FolderTreeNode {
  readonly filter: readonly TagId[];
  readonly name: string;
  readonly subfolders: readonly FolderTreeNode[];
}

const FolderTreeNodeSchema: ZodType<FolderTreeNode> = z.object(
  {
    filter: z.array(TagIdSchema),
    name: z.string(),
    get subfolders() {
      return z.array(FolderTreeNodeSchema);
    },
  },
  {
    filter: "The ids of the tags picked along the folder's path",
    name: "The folder's name, or its tag's name where an expansion made it",
    subfolders: "The folders inside this one",
  },
);

const FolderTreeSchema = z.object(
  { folders: z.array(FolderTreeNodeSchema) },
  { folders: "The tree's top folders" },
);

export type FolderTree = z.infer<typeof FolderTreeSchema>;

export const taxonomyApi = api(
  { domain: API_DOMAIN, path: `${TAXONOMY_SERVICE.LABEL}/api` },
  {
    getFolderTree: apiEndpoint({
      body: z.object(
        { taxonomyId: Taxonomy.shape.id },
        { taxonomyId: "The id of the taxonomy whose folder tree to build" },
      ),
      response: z.object(
        { folderTree: FolderTreeSchema },
        { folderTree: "The taxonomy's folder tree" },
      ),
    }),
  },
);
